import React from 'react';
import HelpDeskInfoModal from './HelpDeskInfoModal';
import { useToggle } from 'react-use';

/**
 * @returns {JSX.Element} a controlled component for the HelpDeskInfoModal where HelpDeskInfoModal
 * can be used directly from ExtJS
 */
function App() {
    const[isOpen, toggleIsOpen] = useToggle(true);

    return <HelpDeskInfoModal isOpen={isOpen}
                              onClose={() => toggleIsOpen(!isOpen)}
                              allowRedirect
                              showStarfishHelpLink />
}

export default App;
